__turbopack_context__.v({
  "tableContainer": "IndicatorTable-modal-module__dUNlmG__tableContainer",
});
